import { BaseAgent } from 'agents';

const UserAgent = {
    uploadAvatar: (avatar) =>
        BaseAgent.upload('/users/form/profile/picture', avatar),
    removeAvatar: () => BaseAgent.del('/users/form/profile/picture'),
    reset: (email) => BaseAgent.post('/profile/password/reset/init', { email }),
    delete: () => BaseAgent.del('/users/profile'),
    deleteFeedback: (feedback) =>
        BaseAgent.post('/profile/feedback', { feedback }),
    requestArchive: () => BaseAgent.post('/account/download_request'),
    available: (email) => BaseAgent.post('/profile/available', { email }),
    policies: () => BaseAgent.get('/payment/profile/policies'),
    update: (data) => BaseAgent.postJson('/users/profile/modify', data),
    getToken: (data) => BaseAgent.postJson('/token/new', data),
    tokenLogin: (token) => BaseAgent.post('/token/check', { token }),
    register: (data) => BaseAgent.post('/signup', data),
    location: () => BaseAgent.get('/location'),
    gifts: () => BaseAgent.post('/payment/gift/details'),
    locale: (locale) => BaseAgent.post('/profile/locale', { locale }),
    getProfile: (uid) => BaseAgent.get(`/profile/${uid}`),
};

export default UserAgent;
